import DirectDebitRequestServiceAgreementPage from '../../src/client/pages/direct-debit-request-service-agreement';

export default DirectDebitRequestServiceAgreementPage;
